export const comments = {
	label: {
		comments: 'Add Comments',
		hideComments: 'Hide Comments',
		add: 'Add',
		delete: 'Delete'
	},
	tooltip: {
		addComment: 'Click to add comment',
		hideComment: 'Click to hide comment',
		addId: 'Add Id',
		reply: 'Reply to comment',
		deleteComment: 'Delete Comment'
	},
	message: {
	}
};
